import { useState, useEffect } from 'react';
import styles from '../styles/components/backToTop.module.scss';

export default function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    function handleScroll() {
      setIsVisible(window.pageYOffset > 200);
    }
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  function handleClick() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  if (!isVisible) {
    return null;
  }

  return (
    <div className={styles.backToTop} onClick={handleClick}>
        <img src="../../src/ico_linkarrow_white.svg" alt="" />
    </div>
  );
}
